import { defineComponent } from "vue";
import moment from "moment-timezone";

import { formatingDateOrTime } from "../../../common/vue-helpers/modifiers/value-modifier";

export default defineComponent({
    data() {
        return {
            dateFormat: "dddd, MMM DD, YYYY",
            timeFormat: "hh:mm A",
            _interval: null,
            today: moment(),
            formatingDateOrTime
        };
    },

    computed: {
        timeZone() {
            return moment(this.today).tz(moment.tz.guess()).format("z");
        }
    },

    mounted() {
        this._interval = setInterval(() => {
            this.update();
        }, 1000);
    },

    unmounted() {
        clearInterval(this._interval);
    },

    methods: {
        update(): void {
            this.today = moment();
        }
    }
});
